const state = {
  userInfo: null,
  examInfo: null,
  token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
  xStatusKey: sessionStorage.getItem('xStatusKey') ? sessionStorage.getItem('xStatusKey') : '',
  xStatusVal: sessionStorage.getItem('xStatusVal') ? sessionStorage.getItem('xStatusVal') : '',
  firstLoginFlag: 0, // 0: 不是第一次 1：是第一次
  pathFlag: '',
  notice: '',
  examConfig: null,
  selectForm: null,
  pathParams: null,
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    sessionStorage.setItem('token', token)
  },
  SET_X_STATUS_VAL: (state, val) => {
    state.xStatusVal = val
    sessionStorage.setItem('xStatusVal', val)
  },
  SET_X_STATUS_KEY: (state, key) => {
    state.xStatusKey = key
    sessionStorage.setItem('xStatusKey', key)
  },
  SET_NOTE: (state, notice) => {
    state.notice = notice
  },
  removeCustomHeader: () => {
    state.xStatusKey = ''
    state.xStatusVal = ''
    sessionStorage.removeItem('xStatusKey')
    sessionStorage.removeItem('xStatusVal')
  },
  SET_PATH_PARAMS: (state, payload) => {
    state.pathParams = payload
    sessionStorage.setItem('jumpParams', JSON.stringify(payload))
  },
  SET_FIRST_LOGIN: (state, flag) => {
    state.firstLoginFlag = flag
  },
  SET_PATH_FLAG: (state, flag) => {
    state.pathFlag = flag
  },
  SET_USER: (state, payload) => {
    state.userInfo = payload
  },
  SET_EXAM: (state, payload) => {
    state.examInfo = payload
  },
  SET_EXAM_CONFIG: (state, payload) => {
    state.examConfig = payload
  },
  SET_SELECT_FORM: (state, payload) => {
    state.selectForm = payload
  },
  LOGOUT: (state) => {
    state.token = ''
    state.xStatusVal = ''
    state.pathFlag = ''
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('xStatusVal')
    state.userInfo = null
    state.examInfo = null
    state.examConfig = null
    state.selectForm = null
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
